<div class="label form-group">
  <label>{{ field.subLabel }}</label>
  <div class="form-control">
    <div
      class="disclaimer-content"
      [innerHTML]="field.label"
    ></div>
  </div>
</div>
